<template>
  <dialog :open="isOpen" class="default-dialog">
    <div class="dialog-content">
      <header class="dialog-header">
        <div>
          <h2 class="dialog-title">{{ title }}</h2>
        </div>
        <button @click="closeModal" class="close-icon-button">✖</button>
      </header>

      <main class="dialog-body">
        <table>
          <thead>
            <th>Arrecadação estimada</th>
            <th>Taxa de publicação</th>
          </thead>

          <tbody>
            <tr>
              <td data-label="Arrecadação">
                <span class="inside-text">
                  Entre R$ 0,00 e R$ 100,00
                </span>
              </td>
              <td data-label="Taxa de publicação">
                <span class="inside-text">R$ 5,00</span>
              </td>
            </tr>
            <tr>
              <td data-label="Arrecadação">
                <span class="inside-text">
                  Entre R$ 100,01 e R$ 200,00
                </span>
              </td>
              <td data-label="Taxa de publicação">
                <span class="inside-text">R$ 15,00</span>
              </td>
            </tr>
            <tr>
              <td data-label="Arrecadação">
                <span class="inside-text">
                  Entre R$ 200,01 e R$ 400,00
                </span>
              </td>
              <td data-label="Taxa de publicação">
                <span class="inside-text">R$ 25,00</span>
              </td>
            </tr>
            <tr>
              <td data-label="Arrecadação">
                <span class="inside-text">
                  Entre R$ 400,01 e R$ 700,00
                </span>
              </td>
              <td data-label="Taxa de publicação">
                <span class="inside-text">R$ 35,00</span>
              </td>
            </tr>
            <tr>
              <td data-label="Arrecadação">
                <span class="inside-text">
                  Entre R$ 700,01 e R$ 1.000,00
                </span>
              </td>
              <td data-label="Taxa de publicação">
                <span class="inside-text">R$ 45,00</span>
              </td>
            </tr>
            <tr>
              <td data-label="Arrecadação">
                <span class="inside-text">
                  Entre R$ 1.000,01 e R$ 2.000,00
                </span>
              </td>
              <td data-label="Taxa de publicação">
                <span class="inside-text">R$ 65,00</span>
              </td>
            </tr>
            <tr>
              <td data-label="Arrecadação">
                <span class="inside-text">
                  Entre R$ 2.000,01 e R$ 4.000,00
                </span>
              </td>
              <td data-label="Taxa de publicação">
                <span class="inside-text">R$ 75,00</span>
              </td>
            </tr>
            <tr>
              <td data-label="Arrecadação">
                <span class="inside-text">
                  Entre R$ 4.000,01 e R$ 7.100,00
                </span>
              </td>
              <td data-label="Taxa de publicação">
                <span class="inside-text">R$ 125,00</span>
              </td>
            </tr>
            <tr>
              <td data-label="Arrecadação">
                <span class="inside-text">
                  Entre R$ 7.100,01 e R$ 10.000,00
                </span>
              </td>
              <td data-label="Taxa de publicação">
                <span class="inside-text">
                  R$ 180,00
                </span>
              </td>
            </tr>
            <tr>
              <td data-label="Arrecadação">
                <span class="inside-text">
                  Entre R$ 10.000,01 e R$ 20.000,00
                </span>
              </td>
              <td data-label="Taxa de publicação">
                <span class="inside-text">
                  R$ 220,00
                </span>
              </td>
            </tr>
            <tr>
              <td data-label="Arrecadação">
                <span class="inside-text">
                  Entre R$ 20.000,01 e R$ 30.000,00
                </span>
              </td>
              <td data-label="Taxa de publicação">
                <span class="inside-text">
                  R$ 460,00
                </span>
              </td>
            </tr>
            <tr>
              <td data-label="Arrecadação">
                <span class="inside-text">
                  Entre R$ 30.000,01 e R$ 50.000,00
                </span>
              </td>
              <td data-label="Taxa de publicação">
                <span class="inside-text">
                  R$ 960,00
                </span>
              </td>
            </tr>
            <tr>
              <td data-label="Arrecadação">
                <span class="inside-text">
                  Entre R$ 50.000,01 e R$ 70.000,00
                </span>
              </td>
              <td data-label="Taxa de publicação">
                <span class="inside-text">
                  R$ 1.400,00
                </span>
              </td>
            </tr>
            <tr>
              <td data-label="Arrecadação">
                <span class="inside-text">
                  Entre R$ 70.000,01 e R$ 100.000,00
                </span>
              </td>
              <td data-label="Taxa de publicação">
                <span class="inside-text">
                  R$ 1.900,00
                </span>
              </td>
            </tr>
            <tr>
              <td data-label="Arrecadação">
                <span class="inside-text">
                  Entre R$ 100.000,01 e R$ 150.000,00
                </span>
              </td>
              <td data-label="Taxa de publicação">
                <span class="inside-text">
                  R$ 2.900,00
                </span>
              </td>
            </tr>
            <tr>
              <td data-label="Arrecadação">
                <span class="inside-text">
                  Acima de R$ 150.000,00
                </span>
              </td>
              <td data-label="Taxa de publicação">
                <span class="inside-text">
                  R$ 3.800,00
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </main>
    </div>
  </dialog>
</template>

<script>
export default {
  props: {
    isOpen: Boolean,
  },
  data() {
    return {
      title: 'Taxas de publicação',
    };
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.default-dialog {
  border: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999999;
  background: none;
  backdrop-filter: blur(4px);
  background-color: rgba(0, 0, 0, 0.2);
  width: 100vw;
  height: 100vh;
}

dialog {
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s, transform 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
}

dialog[open] {
  opacity: 1;
  pointer-events: inherit;
}

dialog::backdrop {
  backdrop-filter: blur(2px);
  animation: fadein 0.2s linear;
}

.dialog-content {
  width: 90%;
  max-height: 90%;
  overflow: auto;
  max-width: 740px;
  background: white;
  border-radius: 8px;
  padding: 20px;
  z-index: 2;
  transform: scale(0.96);
  transition: transform 0.2s;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

dialog[open] .dialog-content {
  transform: scale(1);
}

.dialog-title {
  font-family: sans-serif;
  font-size: 20px;
  color: #111111;
  margin: 0;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.dialog-body {
  margin: 20px 0 0 0;
}

.close-icon-button {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
}

table {
  width: 100%;
  margin: 20px 0;
  color: #33ff77;
  background-color: #0d2031;
  overflow: hidden;
  border-collapse: collapse;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
}

thead {
  display: none;
}

thead th {
  padding: 8px;
  text-align: left;
  color: #33ff77;
  font-weight: bold;
  font-size: 14px;
  text-transform: uppercase;
  text-align: center;
}

tbody tr {
  display: block;
}

tbody td {
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 10px;
  font-size: 14px;
  color: #ffffff;
}

tbody td::before {
  content: attr(data-label);
  float: left;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 12px;
  color: #33ff77;
}

tbody tr:nth-child(odd) {
  background-color: #0f172a;
}

tbody tr:nth-child(even) {
  background-color: #112233;
}

.inside-text {
  font-size: 12px;
}

@media (min-width: 768px) {
  thead {
    display: table-header-group;
  }

  tbody tr {
    display: table-row;
  }

  tbody td {
    display: table-cell;
    text-align: center;
    padding: 4px;
  }

  tbody td::before {
    display: none;
  }

  .dialog-title {
    font-size: 26px;
  }
}
</style>